import qs from "qs";
import axios from "@/services/axios";
import { AxiosResponse } from "axios";

class MessagesLogEventsService {
  getMessageLogEvents(
    params: any,
    sortField: string,
    sortOrder: string,
  ): Promise<AxiosResponse> {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";
    params.sort = sort;
    return axios.get(`/api/message-log-events`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }
  getMessageLogEventsFromTransactionId(
    transaction_id: string,
    params: any,
  ): Promise<AxiosResponse> {
    return axios.get(
      `/api/message-log-events/members?transaction-id=${transaction_id}`,
      {
        params,
      },
    );
  }
  updateMessageStatus(transaction_id: string, status: number): Promise<any> {
    return axios.put(
      `/api/message-log-events/read-status?message_event_log_id=${transaction_id}`,
      { status: status },
    );
  }

  getAcknowledgedInbounds(): Promise<any> {
    return axios.get(`api/message-log-events/not-acknowledged-inbound-events`);
  }

  exportMessageLogs(params: any): Promise<AxiosResponse[]> {
    return axios.post(`/api/message-log-events/message-export`, params);
  }

  getListOfExportedFiles(
    page: number,
    size: number,
    sortField: string,
    sortOrder: string,
  ): Promise<AxiosResponse> {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";

    const params = {
      page,
      size,
      sort,
    };

    return axios.get(`/api/message-log-events/message-export`, { params });
  }
  getAllMessageEventAndMemberLogs(
    params: any,
    sortField: string,
    sortOrder: string,
  ): Promise<AxiosResponse> {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";
    params.sort = sort;
    return axios.get(`/api/message-log-events/logs-view`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }

  getLastReplyForLogView(memberId: string): Promise<AxiosResponse> {
    return axios.get(
      `/api/message-log-events/last-reply?member-id=${memberId}`,
    );
  }

  getAllRepliesByMessageId(memberId: string): Promise<AxiosResponse> {
    return axios.get(`api/message-log-events/replies?member-id=${memberId}`);
  }

  getAllRepliesByRouteId(memberId: string): Promise<AxiosResponse> {
    return axios.get(`api/message-log-events/replies?route-id=${memberId}`);
  }

  fetchTransactionByTransactionId(
    transaction_id: string,
  ): Promise<AxiosResponse> {
    return axios.get(`api/message-log-events/${transaction_id}`);
  }

  updateTagsForTransaction(
    tags: [],
    transaction_id: string,
  ): Promise<AxiosResponse> {
    return axios.put(
      `api/message-log-events/tags?transaction_id=${transaction_id}`,
      tags,
    );
  }

  unlinkInboundFromParent(transactionId: string): Promise<AxiosResponse> {
    return axios.put(`/api/message-log-events/detach-reply`, {
      transactionId: transactionId,
    });
  }
  markAllInboundUnread(): Promise<AxiosResponse> {
    return axios.put(`api/message-log-events/read-all-status`);
  }

  deleteExportFile(id: string): Promise<AxiosResponse> {
    return axios.delete(`api/message-log-events/message-export?id=${id}`);
  }

  updateExportFileStatus(id: string, status: string): Promise<AxiosResponse> {
    return axios.put(
      `api/message-log-events/message-export/update-status?id=${id}&status=${status}`,
    );
  }

  downloadExportFile(id: string): Promise<AxiosResponse> {
    return axios.get(`api/message-log-events/message-export/download?id=${id}`);
  }

  getMessageCreditsCharts(payload: any): any {
    // If filterUserIds array is present in the payload, convert it to be a comma-separated string
    if (
      payload.filterUserIds &&
      Array.isArray(payload.filterUserIds) &&
      payload.filterUserIds.length
    ) {
      payload.filterUserIds = payload.filterUserIds.join(",");
    } else {
      delete payload.filterUserIds;
    }

    // Use URLSearchParams to create query parameters
    const params = new URLSearchParams(payload);
    return axios.get(`/api/message-composite-log/credits-histogram`, {
      params,
    });
  }
}
export const messagesLogEventsService = new MessagesLogEventsService();
